export const langs = [
    {
      label: "lang.fr",
      lang: "fr",
    },
    {
      label: "lang.en",
      lang: "en",
    },
  ];